import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip } from '@material-ui/core';

import Widget from '../../../../../components/Widget/Widget';
import { Typography } from '../../../../../components/Wrappers/Wrappers.jsx';
import AlbatoIframeView from './albatoIframeView';
import { useStyles as useSharedStyles } from '../../styles';
import { useStyles } from './styles';

function ConnectIntegrationPage ({ currentPlan }) {
    const sharedClasses = useSharedStyles();
    const classes = useStyles();

    const planNameUpper = (currentPlan.name || '').toUpperCase();
    const connectTitle = (
        <Box display="flex" alignItems="center" className={classes.planTitleBox}>
            Connect
            {planNameUpper && (
                <Chip label={`${planNameUpper} · ACTIVE`} size="small" className={classes.planActiveChip} />
            )}
        </Box>
    );

    return (
        <div>
            <div className={sharedClasses.widgetContainer}>
                <Widget
                    className={sharedClasses.widgetContainer}
                    buttonFlag={false}
                    title={connectTitle}
                    inheritHeight
                    disableWidgetMenu
                />
            </div>
            <div className={classes.introSection}>
                <Typography variant="h5" weight="bold">
                    Pick the integrations you want to wire up.
                </Typography>
                <Typography variant="body2" className={classes.introDescription}>
                    Every integration is included with your {currentPlan.name} plan. Install as many as you need — you can disconnect or swap any time from Settings.
                </Typography>
            </div>
            <div className={sharedClasses.widgetContainer}>
                <Widget buttonFlag={false} disableWidgetMenu inheritHeight>
                    <Typography variant="h6" weight="bold" className={classes.integrationsHeading}>
                        Your integrations
                    </Typography>
                    <AlbatoIframeView />
                </Widget>
            </div>
        </div>
    );
}

ConnectIntegrationPage.propTypes = {
    currentPlan: PropTypes.shape({
        name: PropTypes.string,
    }).isRequired,
};

export default ConnectIntegrationPage;
